import { UserJourneyEvent } from './user-journey.types';

/** Legacy event names still emitted as strings before full enum migration. */
export const GA_LEGACY_EVENT_NAMES = [
  'buy_sub',
  'registration_password-card_submit',
  'registration_additional-info_submit',
  'landing_sign-in',
  'landing_sign-up',
  'landing_search-click',
  'heatmap_toggle',
  'view_actions_tab',
  'payment_tariff-dialog_manual-pay-click',
] as const;

/** High-volume or diagnostic events tracked on backend only — not forwarded to GA. */
const GA_EXCLUDED_USER_JOURNEY_EVENTS = new Set<string>([
  UserJourneyEvent.PAGE_VIEW,
  UserJourneyEvent.SELECT_PARCEL,
  UserJourneyEvent.PREMIUM_LAYER_ADD,
  UserJourneyEvent.PREMIUM_LAYER_LOADED,
  UserJourneyEvent.PREMIUM_LAYER_ERROR,
  UserJourneyEvent.PREMIUM_LAYER_ZOOM_ISSUE,
  UserJourneyEvent.PREMIUM_LAYER_INTERACT,
  UserJourneyEvent.PREMIUM_LAYER_TOGGLE,
  UserJourneyEvent.PAID_PROJECT_PLOT_CLICK,
  UserJourneyEvent.FREE_PROJECT_PLOT_CLICK,
  UserJourneyEvent.LANGUAGE_SELECTED,
  UserJourneyEvent.VIEW_PRICING,
  UserJourneyEvent.SELECT_PLAN,
  UserJourneyEvent.START_PAYMENT,
  UserJourneyEvent.PURCHASE_COMPLETE,
  UserJourneyEvent.PAYMENT_FAILED,
]);

function buildGaAllowlist(): ReadonlySet<string> {
  const names = new Set<string>();

  for (const value of Object.values(UserJourneyEvent)) {
    if (!GA_EXCLUDED_USER_JOURNEY_EVENTS.has(value)) {
      names.add(value);
    }
  }

  for (const legacy of GA_LEGACY_EVENT_NAMES) {
    names.add(legacy);
  }

  return names;
}

export const GA_EVENT_ALLOWLIST = buildGaAllowlist();

export function isGaAllowlistedEventName(name: string): boolean {
  if (!name || name.startsWith('language_selected_')) {
    return false;
  }

  return GA_EVENT_ALLOWLIST.has(name);
}
